var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('highcharts',{ref:"chart",staticClass:"hc",attrs:{"options":_vm.chart_options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }